// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import VRoute from 'vue-router';
import iView from 'view-design';

// import VueClip from 'vue-clipboard2';
// import VueShare from 'vue-social-share';

import App from './components/App';
import Menus from './vuex/menus';
import store from './vuex/store';

/** NAV请求导航 */
import $navbar from './assets/js/navbar';
/** HTTP请求模块 */
import $https from "./assets/js/request";
/** PLUS模块 */
import $plugins from './assets/js/plugins';
/** CACHE缓存模块 */
import $storage from './assets/js/storage';
/** CACHE缓存模块 */
import $imageph from './assets/js/imageph';

import 'view-design/dist/styles/iview.css';
import './assets/css/common.less';

Vue.use(Vuex);
Vue.use(VRoute);
Vue.use(iView);
// Vue.use(VueClip);
// Vue.use(VueShare);

Vue.prototype.$http = $https; 
Vue.prototype.$plugs = $plugins;
Vue.prototype.$imgph = $imageph;
Vue.prototype.$cache = $storage.cache;
Vue.prototype.$session = $storage.session; 
Vue.config.productionTip = false;

const prod = (process.env.NODE_ENV === 'production'?'':'');
const router = new VRoute({
  mode: 'history', routes: Menus,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) { return { selector: to.hash } }
  }
});
router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  let nextUrl = undefined;
  let toRoute = $navbar.get(to.name);
  let enable  = (toRoute != undefined && toRoute != null && toRoute.funcs.enable);
  if (enable == false) { nextUrl = prod+'/appdown/apps'; }
  window.document.title = toRoute ? toRoute.title : "哎呀！出错啦.";
  if (nextUrl===undefined) { next(); } 
  else { next({ path: nextUrl }); }
});
router.afterEach(() => {
  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});

/* eslint-disable no-new */
new Vue({
  el: '#container',
  store,
  router,
  render: h => h(App)
});

(function () {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function () { callback(currTime + timeToCall); }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }

  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) { clearTimeout(id); };
  }
}());



// WEBPACK FOOTER //
// ./src/main.js